import store from '@/store'
import { Requests, Responses } from './types'
import rethrowApiError from './rethrow-api-error'
import request from '@/helper/superagent-protected'

export async function update(
  settings: Requests.ISettingsUpdate,
): Promise<Responses.ISettingsUpdate> {
  // tslint:disable:no-string-literal
  const apiUrl = store.getters['parameters']('apiUrl')
  return request
    .post(`${apiUrl}/api/settings`)
    .send(settings)
    .set('Accept', 'application/json')
    .then((res: any) => res.body)
    .catch((error: any) => rethrowApiError(error))
}

